import { MarketConfig } from '../../types/markets/MarketConfig';

export default new MarketConfig(
  'zh_TW',
  {
    fdidYouMean: false,
    ffacetNavigation: false,
    fdomainSuggestions: false,
    fvideo: false,
    fCommerceCarrossel: false,
    resultTiles: false,
    dealerWidget: false,
    frelatedsearch: false,
  },
  {
    fssInputCategory: true,
  },
  '51261299-f1dc-4973-bb1d-18409b0845b5',
  ''
);
